// Development configuration
const DEV_CONFIG = {
  SERVER_URL: 'http://localhost:2000',
  // SERVER_URL: 'http://10.240.11.235:2000', // LAN access from another device
  // SERVER_URL: 'http://10.25.191.38:2000',
  // SERVER_URL: 'http://148.66.153.241:2000',
  // SERVER_URL: 'http://www.sendwithcs.com:2000',
};

// Production configuration
const PROD_CONFIG = {
  SERVER_URL: 'https://www.sendwithcs.com/be', // Update this with your production URL
};

// Export the appropriate configuration based on environment
const config = process.env.NODE_ENV === 'production' ? PROD_CONFIG : DEV_CONFIG;

export default config; 